import { getCustomerCompanies, getCustomerCompanyById, } from "../api/generated/wrappers/customer";
import { createQueryKeys } from "./create-query-keys";
const customerCompanyQueryKeys = createQueryKeys("customerCompany", {
    list: (search) => ({
        queryKey: ["list", search],
        queryFn: async () => await getCustomerCompanies(search),
    }),
    detail: (id) => ({
        queryKey: ["detail", id],
        queryFn: async () => await getCustomerCompanyById(id),
    }),
});
export default customerCompanyQueryKeys;
